import React from "react";
import Axios from "axios";
import queryString from "query-string";
import { withTranslation } from "react-i18next";
import { errorMsgs, regexData } from "../../validate_data";

import customClients from "../../customClients";
import FormStepsPreview from "../report-steps/FormStepsPreview";
import PrevStepButton from "../buttons/PrevStepButton";
import SubmitButton from "../buttons/SubmitButton";
import Step1 from "../report-steps/Step1";
import Step2 from "../report-steps/Step2";
import TrackStepsPreview from "../claim-track/TrackStepsPreview";
import {getCurrentLanguage, onLanguageChanged} from '../../i18n'

class ReportForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      //poprawić kształt formData na nowe nazwy pól (tylko standardowe tutaj)
      formData: {
        shop: "amberline",
        redress: "",
        language: getCurrentLanguage(),
      },
      guid: null,
      files: [],
      setFiles: [],
      step: 1,
      status: null,
      complainNumber: null,
      finalStep: 1,
      posts: [],
      loading: false,
      formValidated: false,
      complaintExpectationsLabel: "",
      shopLabel: "amberline",
      shopName: "",
      clients: [],
      errorMessages: [],
      uploadErrors: [],
      invalidFields: [],
      sendStatus: {
        success: null,
        error: null,
      },
    };

    this.appUrl = "";
    this.customClients = customClients;

    let client = this.customClients.find(
      (x) => x.shortName === this.state.shopLabel
    );
    this.dictionaries = client.dictionaries;
    this.requiredFields = client.validation.default;

    this.complaint_expectations = [
      { value: "exchange", label: "Wymiana towaru na nowy" },
      { value: "repair", label: "Naprawa towaru" },
      { value: "reduction", label: "Obniżenie ceny" },
      { value: "withdrawal", label: "Odstąpienie od umowy" },
    ];

    onLanguageChanged((lng) => {
      var formData = this.state.formData;
      formData.language = lng;
      this.setState({
        formData: formData,
      });
      
    });
  }
  componentDidMount() {
    const parsed = queryString.parse(window.location.search);
    if (parsed.guid) {
      this.getTracking(parsed.guid, parsed.tcode);
    }
  }

  async getTracking(guid, tcode) {
    let apiUrl = this.appUrl;
    if (!!tcode) {
      var customPartner = this.customClients.find((x) => x.shortName === tcode);
      if (!!customPartner && !!customPartner.apiUrl) {
        apiUrl = customPartner.apiUrl;
      }
    }
    var response = await Axios.get(apiUrl + `complaints/track/${guid}`);
    if (response.status === 200) {
      this.setState({
        complainNumber: response.data.fieldValues.number_of_complaints,
        status: response.data.activeStages[0].shortName,
        step: 3,
      });
    }
  }

  updateFormData(event) {
    let formData = { ...this.state.formData };
    event.target.type === "checkbox"
      ? event.target.checked
        ? (formData[event.target.name] = event.target.value)
        : (formData[event.target.name] = "")
      : (formData[event.target.name] = event.target.value);

    this.setState({
      formData: formData,
    });
  }

  handleSelectChange(currentValue, event) {
    let formData = { ...this.state.formData };
    formData[event.name] = currentValue.value;

    if (event.name === "type_of_client") {
      if (
        this.customClients.findIndex(
          (x) => x.shortName === this.state.shopLabel
        ) > -1
      ) {
        var client = this.customClients.find(
          (x) => x.shortName === this.state.shopLabel
        );
        this.requiredFields = client.validation.hasOwnProperty(
          formData["type_of_client"]
        )
          ? client.validation[formData["type_of_client"]]
          : client.validation.default;
        this.resetValidateFields();
        this.resetErrors();
      }
    }
    this.setState({
      formData: formData,
    });
  }

  handleUploadChange(file) {
    let files = [...this.state.files];
    let uploadErrors = [...this.state.uploadErrors];
    let totalSize = 0;

    if (file.size < 20000000) {
      files.push(file);
      for (let i = 0; i < files.length; i++) {     
        totalSize += files[i].size;
      }
      if(totalSize > 20000000) {
        uploadErrors.pop(file.name);
        files.pop(file);
        uploadErrors.push(file.name);
      }
      if (!uploadErrors.includes(file.name)) {
        uploadErrors.filter((e) => e !== file.name);
      }
    } else {
      if (!uploadErrors.includes(file.name)) {
        uploadErrors.push(file.name);
      }
    }

    this.setState({
      files: files,
    });

    this.setState({
      uploadErrors: uploadErrors,
    });
  }

  handleFileRemove(event, file) {
    let files = [...this.state.files];
    files = files.filter((item) => item.id !== file.id);

    this.setState({
      files: files,
    });
  }

  onDropRejected(file) {
    let uploadErrors = [...this.state.uploadErrors];
    console.log("rejected");

    if (!uploadErrors.includes("type")) {
      uploadErrors.push("type");
    }

    this.setState({
      uploadErrors: uploadErrors,
    });
  }

  async nextStep() {
    let currentStep = this.state.step;
    let invalidFields = [...this.state.invalidFields];
    let errorMessages = [...this.state.errorMessages];

    if (currentStep < 2) {
      this.setState({
        step: currentStep + 1,
      });
    }
    if (invalidFields.includes("shop")) {
      invalidFields = invalidFields.filter((e) => e !== "shop");
    } else {
      if (!invalidFields.includes("shop")) {
        invalidFields.push("shop");
      }
    }

    await this.setState({
      invalidFields: invalidFields,
    });

    await this.setState({
      errorMessages: errorMessages,
    });
  }

  prevStep() {
    let currentStep = this.state.step;
    if (currentStep > 1) {
      this.setState({
        step: currentStep - 1,
      });
    }
  }

  setStep(number) {
    this.setState({
      step: number,
    });
  }

  setFormValidated() {
    let invalidFields = [...this.state.invalidFields];
    if (invalidFields.length === 0) {
      this.setState({
        formValidated: true,
      });
    } else {
      this.setState({
        formValidated: false,
      });
    }
  }
  resetValidateFields() {
    let invalidFields = [];
    this.setState({
      invalidFields: invalidFields,
    });
  }
  validateFields() {
    let invalidFields = [...this.state.invalidFields];

    this.requiredFields.forEach((element, index) => {
      if (typeof element === "string") {
        if (!this.state.formData[element]) {
          if (!invalidFields.includes(element)) {
            invalidFields.push(element);
          }
        } else {
          invalidFields = invalidFields.filter((e) => e !== element);
        }
      } else if (element.$or) {
        if (element.$or.some((el) => this.state.formData[el])) {
          element.$or.forEach((el) => {
            invalidFields = invalidFields.filter((e) => e !== el);
          });
        } else {
          element.$or.forEach((el) => {
            if (!invalidFields.includes(el)) {
              invalidFields.push(el);
            }
          });
        }
      }
    });

    regexData.forEach((obj) => {
      if (obj.type !== "website") {
        const key =
          obj.type === "email"
            ? "emailRegex"
            : obj.type === "phone"
            ? "phoneRegex"
            : obj.type === "website"
            ? "urlRegex"
            : obj.type === "nip"
            ? "nipRegex"
            : null;
        var field = Object.keys(this.state.formData).find((x) =>
          x.includes(obj.type)
        );
        if (field) {
          if (
            !obj.regex.test(this.state.formData[field]) &&
            this.state.formData[field] !== ""
          ) {
            if (!invalidFields.includes(key)) {
              invalidFields.push(key);
            }
          } else {
            invalidFields = invalidFields.filter((e) => e !== key);
          }
        }
      }
    });
    this.setState({
      invalidFields: invalidFields,
    });
  }
  resetErrors() {
    let errorMessages = [];
    this.setState({
      errorMessages: errorMessages,
    });
  }
  displayErrors() {
    let errorMessages = [...this.state.errorMessages];
    let invalidFields = [...this.state.invalidFields];

    errorMsgs.forEach((error) => {
      if (invalidFields.includes(error.type)) {
        if (!errorMessages.includes(error.msg)) {
          errorMessages.push(error.msg);
        }
      } else {
        errorMessages = errorMessages.filter((e) => e !== error.msg);
      }
    });

    this.setState({
      errorMessages: errorMessages,
    });
  }

  async submitForm(event) {
    event.preventDefault();
    if (this.state.step === this.state.finalStep) {
      await this.validateFields();
      await this.displayErrors();
      await this.setFormValidated();
    }

    if (this.state.formValidated === true) {
      this.setState({
        loading: true,
      });
      let formData = new FormData();
      let formFields = this.state.formData;
      //Trzeba sprawdzić czy wszystkie pola po zmianach nazwy się dobrze wstawiają do FormData
      Object.keys(formFields).forEach((x) => {
        formData.append(x, formFields[x]);
      });
      this.state.files.forEach((x) => {
        var file = new File([x.file], x.name, { type: x.file.type });
        formData.append("complaint_attachments", file, x.name);
      });
      let response;

      let apiUrl = this.appUrl;
      var customPartner = this.customClients.find(
        (x) => x.shortName === this.state.shopLabel
      );
      if (!!customPartner && !!customPartner.apiUrl) {
        apiUrl = customPartner.apiUrl;
      }
      response = await Axios.post(
        apiUrl + "complaints/register",
        formData
      )
        // .then((res) => (res))
        // .catch((err) => console.log(err));

      await this.setState({
        loading: false,
        step: 2,
        formValidated: false,
        formData: {
          name: "",
          email: "",
          invoice: "",
          shop: "",
          tel: "",
          complaint_expectations: "",
          attachments: "",
        },
        guid: response.data && response.data.guid,
        sendStatus: {
          success:
            response && response.status === 200
              ? "Dziękujemy za wysłanie formularza"
              : null,
          error: !response ? "Coś poszło nie tak..." : null,
        },
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.step !== this.state.step) {
      this.setState({
        invalidFields: [],
        errorMessages: [],
      });
    }
  }

  render() {
    const { t } = this.props;
    return (
      <React.Fragment>
        <div id="report-form">
          <form onSubmit={this.submitForm.bind(this)} noValidate>
            {this.state.step !== 3 && (
              <FormStepsPreview step={this.state.step} />
            )}
            {this.state.step === 3 && (
              <TrackStepsPreview
                status={this.state.status}
                complainNumber={this.state.complainNumber}
              />
            )}

            {this.state.step === 1 ? (
              <Step1
                updateFormData={this.updateFormData.bind(this)}
                dictionaries={this.dictionaries}
                formData={this.state.formData}
                invalidFields={this.state.invalidFields}
                errorMessages={this.state.errorMessages}
                files={this.state.files}
                handleUploadChange={this.handleUploadChange.bind(this)}
                handleFileRemove={this.handleFileRemove.bind(this)}
                options={this.complaint_expectations}
                handleSelectChange={this.handleSelectChange.bind(this)}
                redressLabel={this.state.complantiExpcetationsLabel}
                uploadErrors={this.state.uploadErrors}
                requiredFields={this.requiredFields}
                onDropRejected={this.onDropRejected.bind(this)}
              />
            ) : null}

            {this.state.step === 2 ? (
              <Step2
                status={this.state.sendStatus}
                guid={this.state.guid}
                tcode={this.state.shopLabel}
              />
            ) : null}

            {this.state.step !== 2 ? (
              <div className="form-buttons">
                {this.state.step > 1 && this.state.step < 3 ? (
                  <PrevStepButton onClick={this.prevStep.bind(this)} />
                ) : null}

                {this.state.step === this.state.finalStep ? (
                  <SubmitButton
                    loading={this.state.loading}
                    value={t("lodgeAComplaint")}
                  />
                ) : null}
              </div>
            ) : null}
          </form>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation("lodgeAComplaint")(ReportForm);
